{
  "recruitment.title": "Hiring",
  "recruitment.subtitle": "Openings, candidates and interviews, from the first application to the first day.",
  "recruitment.tabs.label": "Hiring sections",
  "recruitment.tabs.openings": "Openings",
  "recruitment.tabs.candidates": "Candidates",
  "recruitment.tabs.interviews": "My interviews",
  "recruitment.stage.applied": "Applied",
  "recruitment.stage.screening": "Screening",
  "recruitment.stage.interview": "Interview",
  "recruitment.stage.assessment": "Assessment",
  "recruitment.stage.offer": "Offer",
  "recruitment.stage.hired": "Hired",
  "recruitment.stageShort.applied": "Applied",
  "recruitment.stageShort.screening": "Screen",
  "recruitment.stageShort.interview": "Interview",
  "recruitment.stageShort.assessment": "Assess",
  "recruitment.stageShort.offer": "Offer",
  "recruitment.applicationStatus.active": "In progress",
  "recruitment.applicationStatus.rejected": "Rejected",
  "recruitment.applicationStatus.withdrawn": "Withdrew",
  "recruitment.applicationStatus.hired": "Hired",
  "recruitment.openingStatus.draft": "Draft",
  "recruitment.openingStatus.open": "Open",
  "recruitment.openingStatus.on_hold": "On hold",
  "recruitment.openingStatus.closed": "Closed",
  "recruitment.openingFilter.all": "All",
  "recruitment.openingFilter.open": "Open",
  "recruitment.openingFilter.on_hold": "On hold",
  "recruitment.openingFilter.draft": "Drafts",
  "recruitment.openingFilter.closed": "Closed",
  "recruitment.employmentKind.full_time": "Full time",
  "recruitment.employmentKind.part_time": "Part time",
  "recruitment.employmentKind.freelance": "Freelance",
  "recruitment.employmentKind.internship": "Internship",
  "recruitment.source.careers_site": "Careers page",
  "recruitment.source.referral": "Referral",
  "recruitment.source.linkedin": "LinkedIn",
  "recruitment.source.agency": "Agency",
  "recruitment.source.other": "Other",
  "recruitment.interviewKind.video": "Video interview",
  "recruitment.interviewKind.phone": "Phone call",
  "recruitment.interviewKind.onsite": "At the office",
  "recruitment.interviewKind.task_review": "Task review",
  "recruitment.interviewStatus.scheduled": "Scheduled",
  "recruitment.interviewStatus.done": "Done",
  "recruitment.interviewStatus.cancelled": "Cancelled",
  "recruitment.recommendation.strong_yes": "Strong yes",
  "recruitment.recommendation.yes": "Yes",
  "recruitment.recommendation.no": "No",
  "recruitment.recommendation.strong_no": "Strong no",
  "recruitment.rating.1": "Poor",
  "recruitment.rating.2": "Weak",
  "recruitment.rating.3": "Okay",
  "recruitment.rating.4": "Good",
  "recruitment.rating.5": "Excellent",
  "recruitment.offerStatus.draft": "Draft",
  "recruitment.offerStatus.sent": "Sent",
  "recruitment.offerStatus.accepted": "Accepted",
  "recruitment.offerStatus.declined": "Declined",
  "recruitment.offerStatus.withdrawn": "Withdrawn",
  "recruitment.closedFilter.all": "All",
  "recruitment.closedFilter.rejected": "Rejected",
  "recruitment.closedFilter.withdrawn": "Withdrew",
  "recruitment.closedFilter.hired": "Hired",
  "recruitment.openings.filterLabel": "Show openings",
  "recruitment.openings.search": "Search openings",
  "recruitment.openings.new": "New opening",
  "recruitment.openings.loadError": "We couldn't load the openings.",
  "recruitment.openings.emptyTitle": "No openings yet",
  "recruitment.openings.emptyBody": "Create an opening, publish it on the careers page, and candidates start arriving here.",
  "recruitment.openings.emptyMine": "No openings for you",
  "recruitment.openings.emptyMineBody": "Openings you're the hiring manager for show here. Interviews you sit on are under My interviews.",
  "recruitment.openings.noMatch": "No openings match",
  "recruitment.openings.noMatchBody": "Try another filter or search.",
  "recruitment.openings.clearFilters": "Clear filters",
  "recruitment.opening.headcount": "{count, plural, one {# hire} other {# hires}}",
  "recruitment.opening.hiringManager": "Hiring manager",
  "recruitment.opening.noManager": "No hiring manager",
  "recruitment.opening.actions": "Actions for {title}",
  "recruitment.opening.manage": "Manage",
  "recruitment.opening.edit": "Edit opening",
  "recruitment.opening.publish": "Publish on the careers page",
  "recruitment.opening.reopen": "Reopen to applicants",
  "recruitment.opening.hold": "Put on hold",
  "recruitment.opening.close": "Close opening",
  "recruitment.opening.published": "The opening is live on the careers page.",
  "recruitment.opening.held": "The opening is on hold and off the careers page.",
  "recruitment.opening.closed": "The opening is closed.",
  "recruitment.opening.copyLink": "Copy careers page link",
  "recruitment.opening.closeTitle": "Close “{title}”?",
  "recruitment.opening.closeBody": "It leaves the careers page and takes no more applications. Its pipeline stays readable, and candidates still in it aren't rejected for you.",
  "recruitment.funnel.label": "{count, plural, one {# active candidate by stage} other {# active candidates by stage}}",
  "recruitment.form.newTitle": "New opening",
  "recruitment.form.editTitle": "Edit opening",
  "recruitment.form.description": "Write the job in both languages: the website shows the one its visitor reads.",
  "recruitment.form.step.job": "The job",
  "recruitment.form.step.details": "How it works",
  "recruitment.form.step.description": "Description",
  "recruitment.form.step.descriptionHint": "What the role does, who you're looking for, and what you offer.",
  "recruitment.form.titleAr": "Title in Arabic",
  "recruitment.form.titleEn": "Title in English",
  "recruitment.form.slug": "Careers page link",
  "recruitment.form.slugHint": "Lowercase English letters, digits and dashes. Leave it empty to make it from the English title.",
  "recruitment.form.slugPreview": "Link:",
  "recruitment.form.slugChanged": "Changing the link breaks links you already shared.",
  "recruitment.form.employmentKind": "Kind of work",
  "recruitment.form.workMode": "Where they work",
  "recruitment.form.department": "Department",
  "recruitment.form.location": "Location",
  "recruitment.form.locationPlaceholder": "Cairo, New Cairo office",
  "recruitment.form.headcount": "People to hire",
  "recruitment.form.headcountHint": "The opening closes once this many are hired.",
  "recruitment.form.hiringManager": "Hiring manager",
  "recruitment.form.hiringManagerHint": "They move candidates, add notes and schedule interviews for this job.",
  "recruitment.form.hiringManagerNone": "No hiring manager",
  "recruitment.form.descriptionAr": "Description in Arabic",
  "recruitment.form.descriptionEn": "Description in English",
  "recruitment.form.create": "Create opening",
  "recruitment.form.save": "Save changes",
  "recruitment.form.created": "Opening created as a draft. Publish it when it's ready.",
  "recruitment.form.saved": "Opening saved.",
  "recruitment.form.errors.titleAr": "Write the title in Arabic.",
  "recruitment.form.errors.titleEn": "Write the title in English.",
  "recruitment.form.errors.tooLong": "This is too long.",
  "recruitment.form.errors.slug": "Use lowercase English letters, digits and dashes.",
  "recruitment.form.errors.slugNeeded": "Choose a link: the English title has no English letters to make one from.",
  "recruitment.form.errors.headcount": "Enter a number from 1 to 50.",
  "recruitment.department.none": "No department",
  "recruitment.picker.search": "Search people",
  "recruitment.picker.empty": "Nobody matches.",
  "recruitment.board.hiringManager": "Hiring manager: {name}",
  "recruitment.board.closedButton": "Closed",
  "recruitment.board.addCandidate": "Add candidate",
  "recruitment.board.loadError": "We couldn't load the pipeline.",
  "recruitment.board.column": "{column}: {count, plural, one {# candidate} other {# candidates}}",
  "recruitment.board.empty": "Nobody at this stage.",
  "recruitment.board.emptyDrop": "Drop a candidate here.",
  "recruitment.board.hiredHint": "People land here when you hire them from an accepted offer.",
  "recruitment.board.applied": "Applied {when}",
  "recruitment.board.moveTo": "Move {name} to…",
  "recruitment.board.moveToShort": "Move to…",
  "recruitment.board.moved": "{name} moved to {column}.",
  "recruitment.board.moveConflict": "Someone changed this candidate meanwhile. The board reloaded; try again.",
  "recruitment.board.stagesLabel": "Pipeline stages",
  "recruitment.board.picked": "Picked up {name}.",
  "recruitment.board.over": "{name} is over {column}.",
  "recruitment.board.dropped": "{name} dropped in {column}.",
  "recruitment.board.cancelled": "Moving {name} was cancelled.",
  "recruitment.board.instructions": "Press Space to pick a candidate up, arrow keys to move between stages and places, Space again to drop, Escape to cancel. Or use the Move to… menu.",
  "recruitment.closed.title": "Closed applications",
  "recruitment.closed.filterLabel": "Show closed applications",
  "recruitment.closed.applied": "Applied {date}",
  "recruitment.closed.empty": "Nothing here",
  "recruitment.closed.emptyBody": "Rejected, withdrawn and hired candidates show here.",
  "recruitment.candidateForm.title": "Add a candidate",
  "recruitment.candidateForm.description": "For someone who came another way: a referral, LinkedIn or an agency. They start at Applied.",
  "recruitment.candidateForm.name": "Full name",
  "recruitment.candidateForm.email": "Email",
  "recruitment.candidateForm.phone": "Phone",
  "recruitment.candidateForm.linkedin": "LinkedIn profile",
  "recruitment.candidateForm.portfolio": "Portfolio",
  "recruitment.candidateForm.source": "Where they came from",
  "recruitment.candidateForm.referrer": "Referred by",
  "recruitment.candidateForm.referrerNone": "Choose who referred them",
  "recruitment.candidateForm.note": "Note",
  "recruitment.candidateForm.noteHint": "Shown on the application's timeline.",
  "recruitment.candidateForm.submit": "Add candidate",
  "recruitment.candidateForm.added": "{name} added at Applied.",
  "recruitment.candidateForm.errors.name": "Write their name.",
  "recruitment.candidateForm.errors.email": "Enter an email, such as name@example.com.",
  "recruitment.candidateForm.errors.url": "Enter a full link starting with https://.",
  "recruitment.application.loadError": "We couldn't load this application.",
  "recruitment.application.summary": "Applied for {title} on {date} · {label}",
  "recruitment.application.reject": "Reject",
  "recruitment.application.withdraw": "Candidate withdrew",
  "recruitment.application.more": "More actions",
  "recruitment.application.reopen": "Reopen",
  "recruitment.application.reopened": "{name} is back in the pipeline.",
  "recruitment.application.rejectTitle": "Reject {name}?",
  "recruitment.application.rejectBody": "Say why, for the team's record. The candidate isn't emailed.",
  "recruitment.application.withdrawTitle": "{name} withdrew?",
  "recruitment.application.withdrawBody": "Record why they withdrew, for the team's record.",
  "recruitment.application.rejected": "{name} was rejected.",
  "recruitment.application.withdrawn": "{name} is marked as withdrawn.",
  "recruitment.banner.rejected": "Rejected",
  "recruitment.banner.withdrawn": "The candidate withdrew",
  "recruitment.banner.hiredTitle": "{name} was hired",
  "recruitment.banner.hired": "Hired on {date}.",
  "recruitment.banner.openRecord": "Open their record",
  "recruitment.banner.erasedTitle": "Personal data erased",
  "recruitment.banner.erased": "Erased on {date}. Stages, ratings and dates stay for reporting.",
  "recruitment.candidate.contacts": "Contact details",
  "recruitment.candidate.email": "Email",
  "recruitment.candidate.phone": "Phone",
  "recruitment.candidate.linkedin": "LinkedIn",
  "recruitment.candidate.portfolio": "Portfolio",
  "recruitment.candidate.openCv": "CV",
  "recruitment.cv.title": "CV",
  "recruitment.cv.open": "Open in a new tab",
  "recruitment.cv.none": "No CV on file",
  "recruitment.cv.noneBody": "Candidates added by hand have no CV until they apply on the careers page.",
  "recruitment.cv.previewFailed": "We couldn't show the CV here.",
  "recruitment.cv.frameTitle": "{name}'s CV",
  "recruitment.facts.title": "Candidate",
  "recruitment.facts.source": "Source",
  "recruitment.facts.applied": "Applied",
  "recruitment.facts.consent": "Consent",
  "recruitment.facts.noConsent": "Added by the team, no consent form",
  "recruitment.facts.onFile": "On file since",
  "recruitment.facts.coverLetter": "Cover letter",
  "recruitment.facts.noCoverLetter": "No cover letter.",
  "recruitment.timeline.title": "Activity",
  "recruitment.timeline.someone": "Someone",
  "recruitment.timeline.appliedOnline": "Applied on the careers page",
  "recruitment.timeline.added": "{actor} added the candidate",
  "recruitment.timeline.moved": "{actor} moved them from {from} to {to}",
  "recruitment.timeline.note": "{actor} added a note",
  "recruitment.timeline.interview_scheduled": "{actor} scheduled an interview for {date}",
  "recruitment.timeline.scorecard": "{actor} submitted a scorecard",
  "recruitment.timeline.offer_sent": "{actor} sent the offer",
  "recruitment.timeline.offer_accepted": "The candidate accepted the offer",
  "recruitment.timeline.offer_declined": "The candidate declined the offer",
  "recruitment.timeline.rejected": "{actor} rejected the application",
  "recruitment.timeline.withdrawn": "{actor} recorded that the candidate withdrew",
  "recruitment.timeline.reopened": "{actor} reopened the application",
  "recruitment.timeline.hired": "{actor} hired them as {code}",
  "recruitment.timeline.noteLabel": "Note",
  "recruitment.timeline.notePlaceholder": "Write a note for the hiring team…",
  "recruitment.timeline.noteHint": "Everyone who can see this application reads it, interviewers too.",
  "recruitment.timeline.addNote": "Add note",
  "recruitment.timeline.noteAdded": "Note added.",
  "recruitment.interviews.title": "Interviews",
  "recruitment.interviews.schedule": "Schedule",
  "recruitment.interviews.none": "No interviews yet.",
  "recruitment.interviews.actions": "Interview actions for {name}",
  "recruitment.interviews.reschedule": "Reschedule",
  "recruitment.interviews.markDone": "Mark as done",
  "recruitment.interviews.markedDone": "Interview marked as done.",
  "recruitment.interviews.cancel": "Cancel interview",
  "recruitment.interviews.keep": "Keep it",
  "recruitment.interviews.cancelTitle": "Cancel this interview?",
  "recruitment.interviews.cancelBody": "The panel no longer writes scorecards for it. Schedule a new one if you still want to meet.",
  "recruitment.interviews.cancelled": "Interview cancelled.",
  "recruitment.interviews.join": "Join the meeting",
  "recruitment.interviews.panel": "Interview panel",
  "recruitment.interviews.yourScorecard": "Your scorecard:",
  "recruitment.interviews.editScorecard": "Edit my scorecard",
  "recruitment.interviews.scorecardDue": "Your scorecard is due.",
  "recruitment.interviews.writeScorecard": "Write my scorecard",
  "recruitment.interviews.sentScorecard": "Scorecard sent · {label}",
  "recruitment.interviews.loadError": "We couldn't load your interviews.",
  "recruitment.interviews.mineEmpty": "No interviews yet",
  "recruitment.interviews.mineEmptyBody": "When someone adds you to an interview panel, it shows here with its scorecard.",
  "recruitment.interviews.upcoming": "Upcoming",
  "recruitment.interviews.past": "Past",
  "recruitment.interviews.noUpcoming": "Nothing coming up.",
  "recruitment.interviews.noPast": "No past interviews.",
  "recruitment.interviewForm.title": "Schedule an interview with {name}",
  "recruitment.interviewForm.rescheduleTitle": "Reschedule the interview with {name}",
  "recruitment.interviewForm.description": "The panel gets a notification with the time and place.",
  "recruitment.interviewForm.kind": "Kind",
  "recruitment.interviewForm.date": "Date",
  "recruitment.interviewForm.time": "Time",
  "recruitment.interviewForm.duration": "Length",
  "recruitment.interviewForm.minutes": "{minutes, plural, one {# minute} other {# minutes}}",
  "recruitment.interviewForm.location": "Place or meeting link",
  "recruitment.interviewForm.locationHint": "A room, an address, or a Meet or Zoom link.",
  "recruitment.interviewForm.panel": "Interview panel",
  "recruitment.interviewForm.panelHint": "Each of them writes a scorecard after the interview.",
  "recruitment.interviewForm.panelAdd": "Add an interviewer",
  "recruitment.interviewForm.panelChosen": "Chosen interviewers",
  "recruitment.interviewForm.panelRemove": "Remove {name}",
  "recruitment.interviewForm.submit": "Schedule interview",
  "recruitment.interviewForm.saveReschedule": "Save new time",
  "recruitment.interviewForm.scheduled": "Interview scheduled. The panel was notified.",
  "recruitment.interviewForm.rescheduled": "Interview rescheduled.",
  "recruitment.interviewForm.errors.date": "Choose the day.",
  "recruitment.interviewForm.errors.time": "Choose the time.",
  "recruitment.interviewForm.errors.panel": "Add at least one interviewer.",
  "recruitment.interviewForm.errors.panelMax": "A panel has at most 10 people.",
  "recruitment.scorecards.title": "Scorecards",
  "recruitment.scorecards.average": "Average {rate} of 5 from {count, plural, one {# scorecard} other {# scorecards}}",
  "recruitment.scorecards.tally": "Recommendations",
  "recruitment.scorecards.tallyItem": "{label}: {count}",
  "recruitment.scorecards.none": "No scorecards yet. Each interviewer writes one after their interview.",
  "recruitment.scorecards.heldBack": "The other interviewers' scorecards show here once you submit yours, so nobody is swayed before they decide.",
  "recruitment.scorecard.title": "Your scorecard for {name}",
  "recruitment.scorecard.editTitle": "Edit your scorecard for {name}",
  "recruitment.scorecard.description": "The hiring team reads it. You can revise it until the interview is cancelled.",
  "recruitment.scorecard.rating": "Overall rating",
  "recruitment.scorecard.recommendation": "Recommendation",
  "recruitment.scorecard.strengths": "Strengths",
  "recruitment.scorecard.concerns": "Concerns",
  "recruitment.scorecard.submit": "Submit scorecard",
  "recruitment.scorecard.save": "Save scorecard",
  "recruitment.scorecard.submitted": "Scorecard submitted.",
  "recruitment.scorecard.updated": "Scorecard updated.",
  "recruitment.scorecard.ratedOf": "Rated {count} out of 5",
  "recruitment.scorecard.forInterview": "{label} · {date}",
  "recruitment.scorecard.errors.rating": "Choose a rating.",
  "recruitment.scorecard.errors.recommendation": "Choose a recommendation.",
  "recruitment.offer.title": "Offer",
  "recruitment.offer.description": "Draft it, send the candidate their private link, and hire once they accept.",
  "recruitment.offer.descriptionReader": "Where the offer stands. Pay is visible to recruiters only.",
  "recruitment.offer.none": "No offer yet.",
  "recruitment.offer.noneLive": "No offer in play.",
  "recruitment.offer.draft": "Draft offer",
  "recruitment.offer.edit": "Edit draft",
  "recruitment.offer.send": "Send offer",
  "recruitment.offer.sendAgain": "Send again",
  "recruitment.offer.withdraw": "Withdraw offer",
  "recruitment.offer.expiredHint": "This offer's date has passed, so it cannot be sent again. Withdraw it, then draft a new offer.",
  "recruitment.offer.sendTitle": "Send the offer to {name}?",
  "recruitment.offer.sendBody": "We'll make a private link where {name} reads and answers the offer. Copy it and send it to them by email or WhatsApp: 404 OS doesn't email candidates.",
  "recruitment.offer.sendAgainTitle": "Send the offer to {name} again?",
  "recruitment.offer.sendAgainBody": "A new link replaces the one you shared with {name}; the old one stops working.",
  "recruitment.offer.sent": "Offer sent. Copy the link and share it.",
  "recruitment.offer.withdrawTitle": "Withdraw the offer to {name}?",
  "recruitment.offer.withdrawBody": "Their link stops working. You can draft a new offer later.",
  "recruitment.offer.withdrawn": "Offer withdrawn.",
  "recruitment.offer.linkLabel": "{name}'s private link",
  "recruitment.offer.linkHint": "Anyone with this link can answer the offer; share it only with the candidate.",
  "recruitment.offer.linkHidden": "The link shows once, when the offer is sent. To share it again, send again: a new link replaces the old one.",
  "recruitment.offer.emailIt": "Email it",
  "recruitment.offer.mailSubject": "Your job offer from 404 Creative",
  "recruitment.offer.mailBody": "Hi {name},\n\nYour offer is ready. Read it and answer here:\n{link}\n\n404 Creative",
  "recruitment.offer.readyToHire": "{name} accepted. Hire them to open their account and record.",
  "recruitment.offer.past": "{count, plural, one {# earlier offer} other {# earlier offers}}",
  "recruitment.offer.answerBy": "Answer by {date}",
  "recruitment.offer.when.sent": "Sent {date}",
  "recruitment.offer.when.accepted": "Accepted {date}",
  "recruitment.offer.when.declined": "Declined {date}",
  "recruitment.offer.role": "Role",
  "recruitment.offer.contract": "Contract",
  "recruitment.offer.start": "Start date",
  "recruitment.offer.salary": "Net monthly salary",
  "recruitment.offer.noSalary": "Not stated",
  "recruitment.offer.probation": "Probation",
  "recruitment.offer.expires": "Answer by",
  "recruitment.offerForm.newTitle": "Draft an offer for {name}",
  "recruitment.offerForm.editTitle": "Edit the offer for {name}",
  "recruitment.offerForm.description": "Nothing reaches the candidate until you send it.",
  "recruitment.offerForm.title": "Job title",
  "recruitment.offerForm.contract": "Contract",
  "recruitment.offerForm.startDate": "Start date",
  "recruitment.offerForm.salary": "Net monthly salary",
  "recruitment.offerForm.salaryHint": "In Egyptian pounds, after tax and insurance. Leave it empty to leave pay out of the offer.",
  "recruitment.offerForm.probation": "Probation",
  "recruitment.offerForm.noProbation": "No probation",
  "recruitment.offerForm.months": "{months, plural, one {# month} other {# months}}",
  "recruitment.offerForm.expiresOn": "Answer by",
  "recruitment.offerForm.expiresHint": "After this day the link no longer takes an answer.",
  "recruitment.offerForm.message": "Message to the candidate",
  "recruitment.offerForm.messageHint": "Shown on their offer page.",
  "recruitment.offerForm.save": "Save draft",
  "recruitment.offerForm.saved": "Offer draft saved.",
  "recruitment.offerForm.errors.title": "Write the job title.",
  "recruitment.offerForm.errors.startDate": "Choose the start date.",
  "recruitment.offerForm.errors.salary": "Enter an amount in pounds, such as 15,000.",
  "recruitment.offerForm.errors.expiresOn": "Choose the last day to answer.",
  "recruitment.offerForm.errors.expiresPast": "Choose today or a later day.",
  "recruitment.hire.open": "Hire",
  "recruitment.hire.title": "Hire {name}",
  "recruitment.hire.description": "This opens their staff account, their HR record and their onboarding.",
  "recruitment.hire.stepsLabel": "Hiring steps",
  "recruitment.hire.step.details": "Details",
  "recruitment.hire.step.confirm": "Onboarding and confirm",
  "recruitment.hire.email": "Work email",
  "recruitment.hire.emailHint": "Their invitation goes here; it becomes their sign-in.",
  "recruitment.hire.hireDate": "First day",
  "recruitment.hire.probationEnd": "Probation ends",
  "recruitment.hire.noProbation": "No probation",
  "recruitment.hire.department": "Department",
  "recruitment.hire.manager": "Manager",
  "recruitment.hire.managerHint": "The hiring manager, unless you choose someone else.",
  "recruitment.hire.managerNone": "No manager",
  "recruitment.hire.workMode": "Where they work",
  "recruitment.hire.template": "Onboarding checklist",
  "recruitment.hire.templateHint": "Tasks for HR, their manager and them, from their first day.",
  "recruitment.hire.templateNone": "No checklist",
  "recruitment.hire.whatHappens": "What hiring does",
  "recruitment.hire.explainAccount": "{name} joins the team as a member, with an HR record from the offer's terms.",
  "recruitment.hire.explainRole": "An admin can change their role later.",
  "recruitment.hire.explainInvite": "An invitation to set their password is emailed to {email}.",
  "recruitment.hire.next": "Next",
  "recruitment.hire.back": "Back",
  "recruitment.hire.submit": "Hire {name}",
  "recruitment.hire.doneDialogTitle": "{name} is on the team",
  "recruitment.hire.doneTitle": "Welcome aboard, {name}!",
  "recruitment.hire.doneCode": "Employee code:",
  "recruitment.hire.inviteLink": "Invitation link",
  "recruitment.hire.inviteHint": "We emailed it too. It shows only now; share it if the email doesn't arrive.",
  "recruitment.hire.openRecord": "Open their record",
  "recruitment.hire.errors.email": "Enter their work email.",
  "recruitment.hire.errors.hireDate": "Choose their first day.",
  "recruitment.hire.errors.probationEnd": "Probation ends after the first day.",
  "recruitment.erase.action": "Erase personal data",
  "recruitment.erase.title": "Erase {name}'s data?",
  "recruitment.erase.body": "Their name, contacts, links, CV, cover letters and the notes and scorecard comments about them are erased from every application. Stages, ratings and dates stay for reporting.",
  "recruitment.erase.final": "This can't be undone. Do it when the candidate asks to be forgotten.",
  "recruitment.erase.typeName": "Type {name} to confirm",
  "recruitment.erase.confirm": "Erase data",
  "recruitment.erase.done": "The candidate's data was erased.",
  "recruitment.erase.sectionTitle": "Erase on request",
  "recruitment.erase.sectionBody": "Under Egypt's data protection law, a candidate can ask us to forget them.",
  "recruitment.candidates.title": "Candidate",
  "recruitment.candidates.intro": "Everyone who applied or was added, most recently active first.",
  "recruitment.candidates.search": "Search by name or email",
  "recruitment.candidates.loadError": "We couldn't load the candidates.",
  "recruitment.candidates.empty": "No candidates yet",
  "recruitment.candidates.emptyBody": "Candidates appear when they apply on the careers page or you add them to an opening.",
  "recruitment.candidates.noMatch": "Nobody matches",
  "recruitment.candidates.noMatchBody": "Try part of their name or email.",
  "recruitment.candidates.since": "Since {date}",
  "recruitment.candidates.consent": "Consented {date}",
  "recruitment.candidates.applications": "{count, plural, one {# application} other {# applications}}",
  "recruitment.public.pageTitle": "Your job offer",
  "recruitment.public.switch": "العربية",
  "recruitment.public.greeting": "Dear {name},",
  "recruitment.public.headline": "We'd love you to join us as {title}",
  "recruitment.public.salary": "Net monthly salary",
  "recruitment.public.expires": "Please answer by",
  "recruitment.public.message": "A message from the team",
  "recruitment.public.answerTitle": "Your answer",
  "recruitment.public.note": "Note (optional)",
  "recruitment.public.noteHint": "Anything you'd like the team to know.",
  "recruitment.public.accept": "Accept offer",
  "recruitment.public.decline": "Decline",
  "recruitment.public.final": "Your answer is final and goes straight to the hiring team.",
  "recruitment.public.acceptTitle": "Accept this offer?",
  "recruitment.public.declineTitle": "Decline this offer?",
  "recruitment.public.confirmBody": "You can't change your answer afterwards.",
  "recruitment.public.acceptConfirm": "Yes, accept",
  "recruitment.public.declineConfirm": "Yes, decline",
  "recruitment.public.acceptedTitle": "You accepted on {date}",
  "recruitment.public.acceptedBody": "Welcome aboard! We'll be in touch about your first day.",
  "recruitment.public.declinedTitle": "You declined on {date}",
  "recruitment.public.declinedBody": "Thank you for letting us know. We wish you the very best.",
  "recruitment.public.expiredTitle": "This offer expired on {date}",
  "recruitment.public.expiredBody": "Contact us if you're still interested.",
  "recruitment.public.withdrawnTitle": "This offer was withdrawn",
  "recruitment.public.withdrawnBody": "Contact the person who sent it if you have questions.",
  "recruitment.public.invalidTitle": "This link isn't valid",
  "recruitment.public.invalidBody": "It may be old or mistyped. Ask the person who sent it for a new one.",
  "recruitment.public.loadError": "We couldn't load the offer",
  "recruitment.public.loadErrorBody": "Check your connection and try again.",
  "recruitment.public.footer": "Questions? Reply to the person who sent you this link.",
  "recruitment.errors.alreadyApplied": "This person already applied for this job.",
  "recruitment.errors.slugTaken": "Another opening already uses this link.",
  "recruitment.errors.applicationClosed": "This application was rejected, withdrawn or hired.",
  "recruitment.errors.offerState": "That step doesn't apply to the offer as it stands. Reload to see where it is.",
  "recruitment.errors.offerLinkInvalid": "This offer link isn't valid any more.",
  "recruitment.errors.offerExpired": "This offer has expired.",
  "recruitment.errors.emailTaken": "Someone on the team already uses this email.",
  "recruitment.errors.conflict": "Someone else changed this meanwhile. Reload and try again.",
  "recruitment.errors.notFound": "This isn't there any more.",
  "recruitment.errors.rateLimited": "Too many tries. Wait a minute and try again.",
  "recruitment.offer.expiryPassed": "The answer-by day has passed. Edit the draft, or withdraw the offer and draft a new one, with a later day."
}
